var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13C17.56 13 16.69 13.33 16 13.88C15.08 14.61 14.5 15.74 14.5 17C14.5 17.75 14.71 18.46 15.08 19.06C15.77 20.22 17.04 21 18.5 21C19.51 21 20.43 20.63 21.13 20C21.44 19.74 21.71 19.42 21.92 19.06C22.29 18.46 22.5 17.75 22.5 17C22.5 14.79 20.71 13 18.5 13ZM20.57 16.57L18.44 18.54C18.3 18.67 18.11 18.74 17.93 18.74C17.74 18.74 17.55 18.67 17.4 18.52L16.41 17.53C16.12 17.24 16.12 16.76 16.41 16.47C16.7 16.18 17.18 16.18 17.47 16.47L17.95 16.95L19.55 15.47C19.85 15.19 20.33 15.21 20.61 15.51C20.89 15.81 20.87 16.28 20.57 16.57Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.5901 21.5C21.5901 21.78 21.3701 22 21.0901 22H3.91016C3.63016 22 3.41016 21.78 3.41016 21.5C3.41016 17.36 7.49015 14 12.5002 14C13.5302 14 14.5302 14.14 15.4502 14.41C14.8602 15.11 14.5002 16.02 14.5002 17C14.5002 17.75 14.7101 18.46 15.0801 19.06C15.2801 19.4 15.5401 19.71 15.8401 19.97C16.5401 20.61 17.4702 21 18.5002 21C19.6202 21 20.6302 20.54 21.3502 19.8C21.5102 20.34 21.5901 20.91 21.5901 21.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C15.2614 12 17.5 9.76142 17.5 7C17.5 4.23858 15.2614 2 12.5 2C9.73858 2 7.5 4.23858 7.5 7C7.5 9.76142 9.73858 12 12.5 12Z",
    fill: "#F1F2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d8deb4fed7daf92f18d4f45ccd2db73.svg";
export { ForwardRef as ReactComponent };